var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"Choose Pharmacy (Demographics)","filter":r => r.notebook === 'Demo-ChoosePharmacy',"scan-results":_vm.scanResults}},[_vm._v(" Choose Pharmacy sends a single demographic file for the whole of Wales each day. This file was not received (so far) on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }